import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING, EDIT } from "const"
import { CcResponse } from "server/models"
import { StateType, deepCopy, hasAccess, hasProjectAccess } from "client/utils"
import {
    PRM_ACCOUNT_SETTINGS,
    PRM_PROJECT_SETTINGS,
    StoreType,
    CcResponseList,

    LoadCcResponses,
    DeleteCcResponse,
    DragnDropCcResponse,

    setCcResponseList,
    setCcModuleResponseList,
    addModal,
} from "client/store"
import {
    Container,
    Loader,
    Button,
    Table,
    DeleteRow,
    DragnDrop,
} from "client/components"

import Columns from "./columns"
import Edit from "../edit"

interface ResponseListProps {
    module: number
}

const List = ({
    module,
}: ResponseListProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const responseList = useSelector((state: StoreType) => state.ccResponse.responseList)
    const moduleResponseList = useSelector((state: StoreType) => state.ccResponse.moduleResponseList)
    const reloadList = useSelector((state: StoreType) => state.ccResponse.reloadList)

    const accountSettings = useSelector((state: StoreType) => state.system.accountSettings)
    const projectSettings = useSelector((state: StoreType) => state.project.projectSettings)
    const { defaultResponsesAssigned } = project.id ? projectSettings.cc : accountSettings.cc

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const LoadData = () => {
        setLoadState(PENDING)
        LoadCcResponses(userData.accountId, project.id, module)
        .then((res) => {
            dispatch(setCcResponseList(res.responseList))
            dispatch(setCcModuleResponseList({ [module]: res.responseIds }))
            setLoadState(IDLE)
        })
    }

    useEffect(() => {
        if (!reloadList) return
        LoadData()
    }, [reloadList, project, defaultResponsesAssigned])

    const onDelete: DeleteRow = (response: CcResponse, callback) => {
        DeleteCcResponse(response.id).then((removedRows) => {
            const success = removedRows === 1
            callback(success, () => {
                const responseListCopy: CcResponseList = responseList ? deepCopy(responseList) : {}
                delete responseListCopy[response.id]
                dispatch(setCcResponseList(responseListCopy))
                dispatch(setCcModuleResponseList({
                    [module]: moduleResponseList[module].filter((id) => id !== response.id),
                }))
            })
        })
    }

    const onDragnDrop: DragnDrop = (dataIds, callback) => {
        dispatch(setCcModuleResponseList({ [module]: dataIds }))
        setLoadState(PENDING)
        DragnDropCcResponse(dataIds, responseList).then((success) => {
            LoadData()
            callback(success)
        })
    }

    const editAccess = !project.id
        ? hasAccess(PRM_ACCOUNT_SETTINGS, EDIT)
        : hasProjectAccess(PRM_PROJECT_SETTINGS, EDIT)

    const columns = Columns(editAccess, module)
    return (
        <Container>
            {
                loadState === PENDING
                && <Loader />
            }
            <Table
                columns={columns}
                dataList={responseList}
                dataIds={moduleResponseList[module]}
                rowSize="sm"
                showPagination={false}
                onDelete={onDelete}
                onDragnDrop={onDragnDrop}
                bottomContent={editAccess && (
                    <Button
                        variant="success"
                        onClick={() => dispatch(addModal({
                            key: "addResponse",
                            content: <Edit responseId={0} module={module} />,
                        }))}
                    >
                        {lang.add}
                    </Button>
                )}
            />
        </Container>
    )
}
export default List
